import { render } from "./ManagePermission.vue?vue&type=template&id=01323f77&scoped=true"
import script from "./ManagePermission.vue?vue&type=script&lang=js"
export * from "./ManagePermission.vue?vue&type=script&lang=js"

import "./ManagePermission.vue?vue&type=style&index=0&id=01323f77&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01323f77"]])

export default __exports__